import { component } from 'picoapp';
import { subscribe as klaviyoSubscribe } from 'klaviyo-subscribe';
import { clear } from 'utils/node';

interface NewsletterConfig {
  klaviyoListId: string
}

interface KlaviyoSubscribeResponse {
  data: {
    is_subscribed?: boolean
  }
  errors: string[]
  success: boolean
}

export default component(async (node) => {
  const form = node.querySelector<HTMLFormElement>('[data-form]');
  const submitBtn = node.querySelector<HTMLButtonElement>('[data-submit-btn]');
  const successMessage = node.querySelector<HTMLElement>('[data-success-message]');
  const errorMessage = node.querySelector<HTMLElement>('[data-error-message]');

  const config: NewsletterConfig = JSON.parse(node.dataset.config);
  const { klaviyoListId } = config;

  const initForm = () => {
    const submitForm = async () => {
      const btnHtml = submitBtn.innerHTML;
      const btnWidth = submitBtn.getBoundingClientRect().width;

      submitBtn.disabled = true;
      submitBtn.style.width = `${btnWidth}px`;
      submitBtn.innerHTML = window.theme.icons.loading;

      const formData = new FormData(form);
      const email = formData.get('email');
      const name = formData.get('name');

      const response: KlaviyoSubscribeResponse = await klaviyoSubscribe(
        klaviyoListId,
        email,
        {
          $first_name: name,
          $fields: ['Accepts Marketing'],
          'Accepts Marketing': true,
        },
      );

      submitBtn.style.width = '';
      submitBtn.innerHTML = btnHtml;
      submitBtn.disabled = false;

      return response;
    };

    const handleResponse = (response: KlaviyoSubscribeResponse) => {
      const clearMessages = () => {
        successMessage.hidden = true;
        errorMessage.hidden = true;

        clear(errorMessage);
      };

      const updateMessages = () => {
        if (response.success && !response.data.is_subscribed) {
          successMessage.hidden = false;
        } else {
          response.errors.forEach((error) => {
            errorMessage.insertAdjacentHTML('beforeend', `<p>${error}</p>`);
          });

          if (response.data.is_subscribed) {
            errorMessage.insertAdjacentHTML(
              'beforeend',
              `<p>${window.theme.strings.newsletter.alreadySubscribed}</p>`,
            );
          }

          errorMessage.hidden = false;
        }
      };

      clearMessages();
      updateMessages();
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const response = await submitForm();
      handleResponse(response);
    });
  };

  const init = () => {
    initForm();
  };

  init();
});
